<template>
  <div style="height: 100vh">
    <a-row :gutter="12">
      <!-- matrix下载 -->
      <a-col
        :xs="{ span: 24 }"
        :sm="{ span: 24 }"
        :md="{ span: 24 }"
        :xl="{ span: 20, offset: 2 }"
        :lg="{ span: 20, offset: 2 }"
        style="margin-top: 10px"
      >
        <a-row>
          <a-col :span="24">
            <a-card
              size="small"
              hoverable
              :headStyle="{ borderRadius: '5px', borderColor: 'transparent' }"
            >
              <a
                slot="title"
                class="guider"
                style="font-size: 20px; color: black"
              >
                Details and access to dataset matrices
              </a>
              Perturbation type :
              <a-radio-group v-model="value" @change="onChange">
                <a-radio :value="1"> Perturb-Seq </a-radio>
                <a-radio :value="2"> Bulk perturbation RNA-Seq </a-radio>
              </a-radio-group>
              <download v-if="this.value == 1" />
              <downloadBulk v-else />
            </a-card>
          </a-col>
        </a-row>
      </a-col>
    </a-row>
  </div>
</template>
<script>
// import scVSbk from "./statistics/scVSbk.vue";
// import genetypes from "./statistics/geneType.vue";
import download from "./download.vue";
import downloadBulk from "./downloadBulk.vue";

export default {
  components: {
    //  scVSbk,
    //   genetypes,
    download,
    downloadBulk,
  },
  methods: {
    onChange(e) {
      this.value = e.target.value;
    },
    goto(value) {
      this.$message.success(value);
    },
  },
  data() {
    return {
      value: 1,
      formLayout: "horizontal",
      customStyle:
        "background: #f7f7f7;border-radius: 4px;margin-bottom: 24px;border: 0;overflow: hidden;font-size:25px;line-height:25px",
    };
  },
};
</script>
<style scpoed>
.h1 {
  font-size: 40px;
  font-weight: bolder;
}
.container {
  display: grid;
  grid-template-columns: auto auto; /* 两列布局 */
  align-items: center; /* 垂直居中 */
  gap: 100px; /* 图像和文本之间的间距 */
}
</style>
